import { render, staticRenderFns } from "./table_keyword.vue?vue&type=template&id=125b5e32"
import script from "./table_keyword.vue?vue&type=script&lang=js"
export * from "./table_keyword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports